export const MORE_POSTS_TITLE_NAMES = {
  reviews: 'Обзоры',
  news: 'Новости',
  offers: 'Акции',
  default: 'Еще посты',
};
